/*
 * @Author: seven.zhang 
 * @Date: 2019-02-13 14:32:55 
 * @Last Modified by: seven.zhang
 * @Last Modified time: 2019-03-22 17:26:01
 */
import Vue from 'vue'

//去除空格
Vue.filter('noGap', function (value) {
  return trim(value);
});

//金钱格式化：每三位逗号 小数点保留两位 --- 例如: 345.12
Vue.filter('money', function (val) {
  val = val.toString().replace(/\$|\,/g, '');
  if (isNaN(val)) {
    val = "0";
  }
  let sign = (val == (val = Math.abs(val)));
  val = Math.floor(val * 100 + 0.50000000001);
  let cents = val % 100;
  val = Math.floor(val / 100).toString();
  if (cents < 10) {
    cents = "0" + cents
  }
  for (var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
    val = val.substring(0, val.length - (4 * i + 3)) + ',' + val.substring(val.length - (4 * i + 3));
  }

  return (((sign) ? '' : '-') + val + '.' + cents);
})

//电话号码过滤，188****7983
Vue.filter('telFormat', function (val) {
  if (val) {
    return val.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2")
  }
});


//num 格式化成带圆圈的num
Vue.filter('circleNum', function (val) {
    if (val) {
        switch(Number(val)){
            case 1:return '①';
            case 2:return '②';
            case 3:return '③';
            case 4:return '④';
            case 5:return '⑤';
            case 6:return '⑥';
            case 7:return '⑦';
            case 8:return '⑧';
            case 9:return '⑨';
            case 10:return '⑩';
            case 11:return '⑪';
        }
    }
});

var noGap = Vue.filter('noGap');
var money = Vue.filter('money');
var telFormat = Vue.filter('telFormat');
var circleNum = Vue.filter('circleNum');

export default {
  noGap, 
  money,
  telFormat,
  circleNum
}